<template>
  <svg
    width="20px"
    height="20px"
    viewBox="0 0 20 20"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <!-- Generator: Sketch 53.2 (72643) - https://sketchapp.com -->
    <title>Group 63</title>
    <desc>Created with Sketch.</desc>
    <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
      <g id="Group-62" :fill="fill">
        <g id="Group-63" transform="translate(-0.000000, -0.000000)">
          <path
            d="M14.7290099,19.9526733 L5.2249505,19.9526733 C3.66574257,19.9526733 2.39712871,18.6847525 2.39712871,17.1270297 L2.39712871,4.32435644 C2.39712871,3.82792079 2.79980198,3.42524752 3.29693069,3.42524752 C3.79405941,3.42524752 4.19683168,3.82792079 4.19683168,4.32435644 L4.19683168,17.1270297 C4.19683168,17.6838614 4.66732673,18.1544554 5.2249505,18.1544554 L14.7290099,18.1544554 C15.2735644,18.1544554 15.7141584,17.6934653 15.7141584,17.1270297 L15.7141584,4.32435644 C15.7141584,3.82792079 16.1171287,3.42524752 16.6141584,3.42524752 C17.1111881,3.42524752 17.5141584,3.82792079 17.5141584,4.32435644 L17.5141584,17.1270297 C17.5141584,18.6847525 16.2646535,19.9526733 14.7290099,19.9526733"
            id="Fill-4"
          />
          <path
            d="M19.0547525,5.22346535 L0.89990099,5.22346535 C0.402772277,5.22346535 -2.46913601e-13,4.82069307 -2.46913601e-13,4.32435644 C-2.46913601e-13,3.82792079 0.402772277,3.42524752 0.89990099,3.42524752 L19.0547525,3.42524752 C19.5517822,3.42524752 19.9537624,3.82792079 19.9537624,4.32435644 C19.9537624,4.82069307 19.5517822,5.22346535 19.0547525,5.22346535"
            id="Fill-5"
          />
          <path
            d="M12.8458416,5.22346535 C12.3488119,5.22346535 11.9458416,4.82069307 11.9458416,4.32435644 L11.9458416,1.79811881 L8.00821782,1.79811881 L8.00821782,4.32435644 C8.00821782,4.82069307 7.60623762,5.22346535 7.10871287,5.22346535 C6.61158416,5.22346535 6.20891089,4.82069307 6.20891089,4.32435644 L6.20891089,0.899108911 C6.20891089,0.402673267 6.61158416,7.32747196e-14 7.10871287,7.32747196e-14 L12.8458416,7.32747196e-14 C13.3428713,7.32747196e-14 13.7448515,0.402673267 13.7448515,0.899108911 L13.7448515,4.32435644 C13.7448515,4.82069307 13.3428713,5.22346535 12.8458416,5.22346535"
            id="Fill-6"
          />
          <path
            d="M7.66465347,15.6710891 C7.16772277,15.6710891 6.7650495,15.2683168 6.7650495,14.7719802 L6.7650495,8.60594059 C6.7650495,8.10950495 7.16772277,7.70683168 7.66465347,7.70683168 C8.16168317,7.70683168 8.56465347,8.10950495 8.56465347,8.60594059 L8.56465347,14.7719802 C8.56465347,15.2683168 8.16168317,15.6710891 7.66465347,15.6710891"
            id="Fill-7"
          />
          <path
            d="M12.2894059,15.6710891 C11.7923762,15.6710891 11.3894059,15.2683168 11.3894059,14.7719802 L11.3894059,8.60594059 C11.3894059,8.10950495 11.7923762,7.70683168 12.2894059,7.70683168 C12.7864356,7.70683168 13.1894059,8.10950495 13.1894059,8.60594059 L13.1894059,14.7719802 C13.1894059,15.2683168 12.7864356,15.6710891 12.2894059,15.6710891"
            id="Fill-8"
          />
        </g>
      </g>
    </g>
  </svg>
</template>
<script>
export default {
  props:{
    fill:{
      type: String,
      default:'#22242A'
    }
  }
}
</script>